import { render, staticRenderFns } from "./EMFormSection.vue?vue&type=template&id=bb3060f8"
import script from "./EMFormSection.vue?vue&type=script&lang=js"
export * from "./EMFormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports